/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '@swisslife/patterns-base/src/molecules/search-box/css/search-box';
import '@swisslife/patterns-base/src/atoms/heading/css/heading';
import '@swisslife/patterns-base/src/molecules/list-filter/css/list-filter';
import '@swisslife/patterns-base/src/atoms/list/css/list';
import '@swisslife/patterns-base/src/atoms/link/css/link';
import './search-result.scss';
